 jQuery(document).ready(function() {
      jQuery(".testimonial-items").slick({
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        nav: true,
        //autoplay: true,
        //autoplaySpeed: 2000,
        //pauseOnHover: true,
 responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }

  ]
      }); 
    });


 jQuery(document).ready(function() {

      jQuery(".collection-slider-wrapper").slick({
        dots: true,
        nav: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
//         autoplay: true,
//         autoplaySpeed: 2000,
//         pauseOnHover: true,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
               infinite: true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }

  ]


      }); 
    });




 var tag = document.createElement('script');
        tag.id = 'iframe-demo';
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        var player;
        function onYouTubeIframeAPIReady() {
            var elems1 = document.getElementsByClassName('yt-player');
            for(var i = 0; i < elems1.length; i++) {
                
                player = new YT.Player(elems1[i], {
                    events: {
                        //'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                });
            }
        }
        function onPlayerReady(event) {
            
        }
        function handleVideo(playerStatus) {
            if (playerStatus == -1) {
                // unstarted
                $('#main-slider').slick('slickPause');
            } else if (playerStatus == 0) {
                // ended
                $('#main-slider').slick('slickPlay');
                
            } else if (playerStatus == 1) {
                // playing = green                
                $('#main-slider').slick('slickPause');                
            } else if (playerStatus == 2) {
                // paused = red
                $('#main-slider').slick('slickPlay');
            } else if (playerStatus == 3) {
                // buffering = purple
            } else if (playerStatus == 5) {
                // video cued
            }
        }
        function onPlayerStateChange(event) {
            handleVideo(event.data);
        }
        
        $(function() {
            $('#main-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                //autoplay: true,
                autoplaySpeed: 3000,
                pauseOnFocus: false,
                pauseOnHover: false,
                dots: true,
                infinite: true,
                adaptiveHeight: true,
                arrows: false
            });

        });
        
        $('#main-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.yt-player').each(function(){
                this.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
            });
        });

